export const setCountDecimals = (price: number, countZero: number) => {
  const count: any = '1'.padEnd(Number(countZero + 1), '0');
  const result: any = (price * count) / count;
  const decimalLength = String(result).split('.')[1]?.length;

  return decimalLength === countZero
    ? String(result)
    : decimalLength > countZero
    ? `${String(result).split('.')[0]}.${String(result).split('.')[1].substr(0, 2)}`
    : result.toFixed(countZero);
};
